// import React, { ReactNode } from "react";
// import { Navigate } from "react-router-dom";
// import { TOKEN } from "../constants/enums";

// interface AuthProtectedProps {
//   children: ReactNode;
// }

// const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
//   if (!localStorage.getItem(TOKEN)) {
//     return <Navigate to={{ pathname: "/login" }} />;
//   }

//   return <React.Fragment>{children}</React.Fragment>;
// };

// export default AuthProtected;


import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { TOKEN } from "../constants/enums";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const token = localStorage.getItem(TOKEN);
  console.log("🔐 AuthProtected - Checking token:", token ? "exists" : "missing");
  
  if (!token) {
    console.log("❌ AuthProtected - No token, redirecting to /login");
    return <Navigate to={{ pathname: "/login" }} />;
  }

  console.log("✅ AuthProtected - Token valid, rendering children");
  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;